import { omit } from "lodash";
import { STEPS } from "..";

/**
 * remove interventions when array is empty
 */
export default function getValidGoals(
  arg: AdvancedTreatmentPlan,
): AdvancedTreatmentPlan {
  if (!arg.goals) {
    return arg;
  }
  const validGoals = arg.goals.filter((el) => !!el.value);
  // remove goals when array is empty
  if (!validGoals.length) {
    return omit(arg, STEPS.goals.id);
  }

  const nextGoals = arg.goals.reduce(
    (prev, curr) => {
      if (!curr.objectives) {
        prev.push(curr);
        return prev;
      }

      const nextObjectives = curr.objectives.reduce(
        (prevObjs, currObj) => {
          // remove interventions when array is empty or empty string
          if (
            !currObj.interventions ||
            !currObj.interventions.filter((el) => !!el).length
          ) {
            prevObjs.push({
              value: currObj.value,
            });
          } else {
            prevObjs.push(currObj);
          }
          return prevObjs;
        },
        [] as {
          value: string;
          interventions?: string[] | undefined;
        }[],
      );
      prev.push({
        ...curr,
        objectives: nextObjectives,
      });
      return prev;
    },
    [] as {
      value: string;
      objectives?:
        | {
            value: string;
            interventions?: string[] | undefined;
          }[]
        | undefined;
    }[],
  );
  return {
    ...arg,
    goals: nextGoals,
  };
}
